<template>
  <div class="plan-home" v-title :data-title='"卓考网校|"+plan.title'>
    <main class="g-view-container">
      <template v-for="item in plan.detail">
        <a :href="item.introUrl" class="plan-item" :key="item.name">
          <i class="iconfont iconjihua"></i>
          <div class="content">
            <div class="title van-ellipsis">{{item.name}}</div>
            <div class="target van-multi-ellipsis--l2">{{item.target}}</div>
          </div>
          <div class="btn-view">查看详情</div>
        </a>
      </template>
      <learning-method v-if="plan.isShowMethods"  />
    </main>
  </div>
</template>

<script>
  import planModel from 'models/plan';
  import LearningMethod from './learning-method';

  export default {
    name: 'Home',
    data() {
      return {
        professionId: this.$route.params.professionId,
      };
    },

    components: {
      LearningMethod,
    },
    created() {
      this.plan = planModel.getPlanByProfessionId(this.professionId);
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
$plan-item-height: 95px;
$theme-color:#2e92fe;

.plan-item {
  @include flex-between();
  margin: 20px auto;
  width: 95%;
  height: $plan-item-height;
  background-color: #fff;

  &:before {
    content: "";
    width: 6px;
    height: $plan-item-height;
    background-color: $theme-color;
    border-radius: 5px 0 0 5px;
  }

  .iconjihua {
    margin-left: 5px;
    font-size: 35px;
    color: $theme-color;
  }

  .content {
    margin: 0 10px;
    flex: 1;
    overflow: hidden;

    .title {
      font-size: 16px;
      color: #fd595a;
      line-height: 2;
      font-weight: bold;
    }

    .target {
      font-size: 11px;
      color: #999;
      line-height: 1.5;
    }
  }

  .btn-view {
    margin-right: 5px;
    padding: 0 10px;
    font-size: 12px;
    color: #fff;
    line-height: 25px;
    background-color: $theme-color;
    border-radius: 12px;
  }
}
</style>
